import styled from 'styled-components';

import { gray5 } from './Const';

export const TitleStyle = styled.h4`
   padding: 0px 12px;
`;

export const ListStyle = styled.div`
    padding: 12px 12px;
`;

export const ArrowContainer = styled.div`
    float: right;
`;

export const Divide = styled.div`
    border-top: 1px solid ${gray5};
`;



// WEBPACK FOOTER //
// ./assets/js/styles/CategoryPulldown.ts